class WishlistUtils {
  static storageKey = "pureveatheme:club-navi-wishlist";
  static getWishlist() {
    const raw = localStorage.getItem(this.storageKey);
    if (!raw) return [];
    try {
      const products = JSON.parse(raw);
      return Array.isArray(products) ? products : [];
    } catch (error) {
      return [];
    }
  }
  static setWishlist(products) {
    if (products.length > 0) {
      localStorage.setItem(this.storageKey, JSON.stringify(products));
    } else {
      localStorage.removeItem(this.storageKey);
    }
  }
  static isInWishlist(productId) {
    return this.getWishlist().some((product) => product.id === productId);
  }
  static addToWishlist(productId, productUrl) {
    const products = this.getWishlist();
    if (!products.some((product) => product.id === productId)) {
      products.push({ id: productId, url: productUrl });
      this.setWishlist(products);
    }
    document.dispatchEvent(
      new CustomEvent("club-navi:wishlist:change", { detail: { products, productId, action: "add" } })
    );
  }
  static removeFromWishlist(productId) {
    const products = this.getWishlist().filter((product) => product.id !== productId);
    this.setWishlist(products);
    document.dispatchEvent(
      new CustomEvent("club-navi:wishlist:change", { detail: { products, productId, action: "remove" } })
    );
  }
  static getCount() {
    return this.getWishlist().length;
  }
  static getSectionUrl(productUrl, sectionId) {
    const separator = productUrl.includes("?") ? "&" : "?";
    return `${productUrl}${separator}sections=${sectionId}`;
  }
}

class WishlistButtonElement extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
    this.addedClass = "active";
    this.productId = this.dataset.productId;
    this.productUrl = this.dataset.productUrl;
    this.titleWishlist = this.dataset.titleWishlist;
    this.titleAddedWishlist = this.dataset.titleAddedWishlist;
    this.context = this.dataset.context;
  }
  get buttonEl() {
    return (this._buttonEl = this._buttonEl || this.querySelector("button"));
  }
  connectedCallback() {
    this.init();
    this.buttonEl.addEventListener("click", this.onClick.bind(this), {
      signal: this.abortController.signal,
    });
    document.addEventListener("club-navi:wishlist:change", this.onWishlistChange.bind(this), {
      signal: this.abortController.signal,
    });
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  init() {
    if (WishlistUtils.isInWishlist(this.productId)) {
      this.changeState(true);
    }
  }
  onClick(event) {
    event.preventDefault();
    gspTheme.helper.enableLoadingSpiner(this);
    if (WishlistUtils.isInWishlist(this.productId)) {
      WishlistUtils.removeFromWishlist(this.productId);
    } else {
      WishlistUtils.addToWishlist(this.productId, this.productUrl);
    }
    setTimeout(() => {
      gspTheme.helper.disableLoadingSpinner(this.buttonEl);
    }, 500);
  }
  onWishlistChange(event) {
    const { productId } = event.detail;
    if (productId === this.productId) {
      this.changeState(WishlistUtils.isInWishlist(this.productId));
    }
  }
  changeState(active) {
    if (this.context === "single") {
      const label = this.querySelector(".btn-label");
      this.buttonEl.classList.toggle(this.addedClass, active);
      if (label) {
        label.textContent = active ? this.titleAddedWishlist : this.titleWishlist;
      }
    } else {
      this.buttonEl.classList.toggle(this.addedClass, active);
      this.updateTooltip(active ? this.titleAddedWishlist : this.titleWishlist);
    }
  }
  updateTooltip(text) {
    this.buttonEl.setAttribute("data-bs-title", text);
    const tooltip = bootstrap.Tooltip.getInstance(this.buttonEl);
    if (tooltip) {
      tooltip.setContent({ ".tooltip-inner": text });
    }
  }
}
customElements.define("wishlist-button", WishlistButtonElement);

class WishlistCountElement extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.update();
    document.addEventListener("club-navi:wishlist:change", this.update.bind(this), {
      signal: this.abortController.signal,
    });
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  update() {
    this.innerText = WishlistUtils.getCount();
  }
}
customElements.define("wishlist-count", WishlistCountElement);

class WishlistGridElement extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
  }
  connectedCallback() {
    document.addEventListener("club-navi:wishlist:change", this.render.bind(this), {
      signal: this.abortController.signal,
    });
    this.render();
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  async render() {
    const products = WishlistUtils.getWishlist();
    const emptyEl = this.querySelector("[data-wishlist-empty]");
    const listEl = this.querySelector("[data-wishlist-list]");
    if (!listEl) return;
    if (products.length === 0) {
      listEl.innerHTML = "";
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    const items = await Promise.all(
      products.map(async (product) => {
        try {
          const response = await fetch(WishlistUtils.getSectionUrl(product.url, "fetch__product-item-grid"));
          const data = await response.json();
          return data["fetch__product-item-grid"] || "";
        } catch (error) {
          return "";
        }
      })
    );
    listEl.innerHTML = items.join("");
  }
}
customElements.define("wishlist-grid", WishlistGridElement);
